'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react'; // Assuming you're using next-auth

/**
 * Following code inserts userId and email into Hotjar only if the window.hj (hj -> hotjar) is available.
 */
const AddUserIdToHotjarScript = () => {
  const { data: session } = useSession();
  const userId = session?.user?.id;
  const email = session?.user?.email;

  useEffect(() => {
    // Identify user if available in session
    if (userId && window.hj) {
      window.hj('identify', userId, {
        email,
      });
    }
  }, [userId, email]);

  return null;
};

export default AddUserIdToHotjarScript;
